import React from "react";
import ButtonStyle from "./buttonstyle";
import { useHistory } from "react-router-dom";

export default function SaveAndContinue({
  isLoading,
  mutation,
  form,
  enabled,
  showBack = true,
  label = "Save & Continue",
  handleClick = null
}) {
  const history = useHistory();
  function handleMutate() {
    const { errors, ...params } = form;
    if (enabled) mutation.mutate(params);
  }
  return (
    <div style={{ marginTop: "1rem" }}>
      {showBack && (
        <button
          disabled={isLoading}
          style={{ ...ButtonStyle({ enabled: enabled }), marginRight: "1rem" }}
          onClick={() => history.goBack()}
        >
          Back
        </button>
      )}
      <button
        disabled={isLoading}
        onClick={() => (handleClick === null ? handleMutate() : handleClick(handleMutate))}
        style={ButtonStyle({ enabled: enabled })}
      >
        {label}
      </button>
    </div>
  );
}
